import { useEnvironment } from '@publicisgroupe/p-os-components';
import { usePermissions } from '@publicisgroupe/pm-shared-authorization';
import { MODULE_NAME } from '../utils/constants';

const useWebframePermissions = () => {
  const env = useEnvironment();
  const permissionUrl = `${env.settings.apiBaseURL}/${MODULE_NAME}`;
  const ocpApimKey = env.settings.ocpApimKey || '';
  return usePermissions(permissionUrl, ocpApimKey, 'Functional');
};
export default useWebframePermissions;
